// src/services/api/insight.ts

import { httpsCallable } from 'firebase/functions';
import { collection, query, where, orderBy, getDocs, Timestamp, limit } from 'firebase/firestore';
import { functions, db } from '../../config/firebase';
import { logger } from '../../utils/logger';
import { Insight } from '../../types/insight';

/**
 * 從 Firestore 直讀用戶的活躍 insights（pending 或 snoozed 但已到時間）
 * 前端直讀，無需 onCall
 */
export const getActiveInsights = async (userId: string): Promise<Insight[]> => {
  try {
    const insightsRef = collection(db, 'users', userId, 'insights');
    const now = Timestamp.now();

    const snap = await getDocs(
      query(insightsRef, where('status', '==', 'pending'), orderBy('createdAt', 'desc'), limit(5))
    );

    const results = snap.docs
      .map(d => ({ id: d.id, ...d.data() } as Insight))
      .filter(i => i.expiresAt.seconds >= now.seconds);
    logger.dev(`InsightAPI 讀取 insights 成功`, { total: snap.size, active: results.length });
    return results;
  } catch (error) {
    logger.error('InsightAPI', '讀取 insights 失敗', error);
    return [];
  }
};

/**
 * 接受建議：將 aiSuggestion 套用到 idealWeek
 */
export const applyInsightSuggestion = async (insightId: string): Promise<void> => {
  const fn = httpsCallable(functions, 'applyInsightSuggestion');
  await fn({ insightId });
};

/**
 * 不用動：dismiss insight
 */
export const dismissInsight = async (insightId: string): Promise<void> => {
  const fn = httpsCallable(functions, 'dismissInsight');
  await fn({ insightId });
};

/**
 * 我來調整後儲存：標記為 self_adjusted
 */
export const markInsightSelfAdjusted = async (insightId: string): Promise<void> => {
  const fn = httpsCallable(functions, 'markInsightSelfAdjusted');
  await fn({ insightId });
};
